import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';
import { AgGridReact } from 'ag-grid-react';
import Modal from 'react-modal';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './UserManager.css';
import UserDetailsDialog from './UserDetailsDialog';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axiosInstance.get('users/');
      setUsers(response.data);
    } catch (error) {
      setError('Error fetching users');
    }
  };
  const openModal = (user = null) => {
    if (user == null) {
      setCurrentUser({ username: '', email: '', first_name:'', last_name:'', type: 'admin', organization_id: null });
    } else {
      if (user.profile.organization != null) {
        user.organization_id = user.profile.organization_id;
      }
      user.type = user.profile.type;
      setCurrentUser(user);
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentUser(null);
  };

  const handleSubmit = (e, resultingUser) => {
    fetchUsers();
    closeModal();
    console.dir("userManager handleSubmit...");
    console.dir(resultingUser);
  };


  const openDeleteModal = (user) => {
    setCurrentUser(user);
    setDeleteModalIsOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setCurrentUser(null);
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`users/${currentUser.id}/`);
      fetchUsers();
      closeDeleteModal();
    } catch (error) {
      setError('Error deleting user');
    }
  };

  const renderEditButton = (params) => (
    <button className="icon-button" onClick={() => openModal(params.data)}>
      <EditIcon />
    </button>
  );

  const renderDeleteButton = (params) => (
    <button className="icon-button" onClick={() => openDeleteModal(params.data)}>
      <DeleteIcon />
    </button>
  );

  const onRowDoubleClicked = (params) => {
    openModal(params.data);
  };

  const columns = [
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          {renderEditButton(params)}
          {renderDeleteButton(params)}
        </>
      ),
      width: 100,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'space-around' }
    },
    { headerName: "Username", field: "username", flex: 1 },
    { headerName: "Email", field: "email", flex: 2 },
    { headerName: "Type", field: "profile.type", flex: 1 },
    { headerName: "Organization", field: "profile.organization_name", flex: 1 }
  ];

  return (
    <div className="users-container">
      <h1>Manage Users</h1>
      <button onClick={() => openModal()} className="add-user-button">Add User</button>
      {error && <div className="error-message">{error}</div>}
      <div
        className="ag-theme-alpine"
        style={{
          height: '400px',
          width: '80%',
          overflow: 'scroll',
        }}
      >
        <AgGridReact
          rowData={users}
          columnDefs={columns}
          domLayout="autoHeight"
          onRowDoubleClicked={onRowDoubleClicked}
          overlayNoRowsTemplate="."
        />
      </div>
      <UserDetailsDialog inputEntity={currentUser} open={modalIsOpen} onClose={closeModal} onSubmit={handleSubmit} showOrganization={true} />
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Confirm Delete</h2>
        <p>Are you sure you want to delete the user "{currentUser && currentUser.username}"?</p>
        <button onClick={handleDelete}>Yes, Delete</button>
        <button onClick={closeDeleteModal}>Cancel</button>
      </Modal>
    </div>
  );
};

export default Users;
